import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find } from '@fretadao/f-js-dom';

application.register('line-daily-boarding-authorizations-index', class extends Controller {
  static targets = ['locationStatus', 'coords']

  connect() {
    this.#fetchGeolocation();
  }

  #fetchGeolocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        this.locationStatusTarget.innerText = 'Localização habilitada';
        this.coordsTargets.forEach(function(element) {
          element.value = position.coords.latitude + ',' + position.coords.longitude;
        })
      }.bind(this))
    } else {
      this.locationStatusTarget.innerText = 'Localização não habilitada';
    }
  }
})
